import { lazy } from 'react'
import generateRouterDetail from 'utils/helpers/generateRouterDetail'
import { referralMissionAddEditRBAC } from 'features/Promotion/pages/ReferralMission/ReferralMissionAddAndEdit/rbac'
import { referralMissionListRBAC } from 'features/Promotion/pages/ReferralMission/ReferralMissionList/rbac'
import { flashSaleRBAC } from 'features/Promotion/pages/FlashSale/rbac'
import { flashSaleAddEditRBAC } from 'features/Promotion/pages/AddEditFlashSale/rbac'
import { uniqueVoucherCampaignListRolesRBAC } from 'features/Promotion/pages/UniqueVoucher/CampaignList/rbac'
import { uniqueVoucherVoucherPromoAddEditRolesRBAC } from 'features/Promotion/pages/UniqueVoucher/VoucherPromoAddAndEdit/rbac'
import { uniqueVoucherVoucherListRolesRBAC } from 'features/Promotion/pages/UniqueVoucher/VoucherList/rbac'
import { giftWithPurchaseRolesRBAC } from '../pages/GiftWithPurchase/rbac'
import {
  giftWithPurchaseAddRolesRBAC,
  giftWithPurchaseEditRolesRBAC,
} from '../pages/GiftWithPurchaseAddEdit/rbac'
import { giftWithPurchaseAddProductRolesRBAC } from '../pages/GiftWithPurchaseAddProduct/rbac'
import { purchaseWithPurchaseRolesRBAC } from '../pages/PurchaseWithPurchase/rbac'
import {
  purchaseWithPurchaseAddRolesRBAC,
  purchaseWithPurchaseEditRolesRBAC,
} from '../pages/PurchaseWithPurchaseAddEdit/rbac'
import { purchaseWithPurchaseAddProductRolesRBAC } from '../pages/PurchaseWithPurchaseAddProduct/rbac'
import { referralVIPRolesRBAC } from '../pages/ReferralVIP/rbac'
import { milestoneListRBAC } from '../pages/MilestoneList/rbac'
import { milestoneAddEditRBAC } from '../pages/MilestoneAddEdit/rbac'
import { flexiComboRolesRBAC } from '../pages/FlexiCombo/rbac'
import { flexiComboCreateRolesRBAC, flexiComboEditRolesRBAC } from '../pages/FlexiComboAddEdit/rbac'
import { flexiComboChooseProductRolesRBAC } from '../pages/PromotionChooseProduct/rbac'
import { enumOriginType } from '../constant/enum'

type NamedRoutesType =
  | 'FlashSaleRouter'
  | 'MilestoneAddEditRouter'
  | 'MilestoneListRouter'
  | 'FlashSaleRouter'
  | 'FlexiComboRouter'
  | 'ReferralMissionRouter'
  | 'ReferralMissionAddEditRouter'
  | 'GiftWithPurchaseRouter'
  | 'GiftWithPurchaseAddRouter'
  | 'GiftWithPurchaseEditRouter'
  | 'GiftWithPurchaseAddProductRouter'
  | 'PurchaseWithPurchaseRouter'
  | 'PurchaseWithPurchaseAddRouter'
  | 'PurchaseWithPurchaseEditRouter'
  | 'PurchaseWithPurchaseAddProductRouter'
  | 'ReferralVIPRouter'
  | 'UniqueVoucherCampaignList'
  | 'UniqueVoucherVoucherList'
  | 'UniqueVoucherVoucherAddEdit'
  | 'FlexiComboAddEdit'
  | 'PromotionChooseProductRouter'
type PathListsType =
  | '/dashboard/flash-sale'
  | '/dashboard/milestone/:prefix(add|edit)/:milestoneId(\\d+)?'
  | '/dashboard/milestone-list'
  | '/dashboard/flash-sale'
  | '/dashboard/flexi-combo'
  | '/dashboard/referral-mission'
  | '/dashboard/referral-mission/:prefix/:id'
  | '/dashboard/gift-with-purchase'
  | '/dashboard/gift-with-purchase/add'
  | '/dashboard/gift-with-purchase/edit/:id'
  | '/dashboard/gift-with-purchase-product-list'
  | '/dashboard/purchase-with-purchase'
  | '/dashboard/purchase-with-purchase/add'
  | '/dashboard/purchase-with-purchase/edit/:id'
  | '/dashboard/purchase-with-purchase/product'
  | '/dashboard/referral-vip/list'
  | '/dashboard/unique-voucher/campaign-list'
  | '/dashboard/unique-voucher/voucher-list'
  | '/dashboard/unique-voucher/voucher/:prefix/:id'
  | '/dashboard/flexi-combo/:prefix(create|edit)/:id?'
  | '/dashboard/promotional/add-product/:origin(flexiComboAdd|flexiComboEdit|pwp)'

type RouterInstanceType = RouterFeatureInterface<NamedRoutesType, PathListsType>

const FlashSalePage = lazy(() => import('../pages/FlashSale'))
const AddEditFlashSale = lazy(() => import('../pages/AddEditFlashSale'))
const MilestoneAddEdit = lazy(() => import('../pages/MilestoneAddEdit'))
const MilestoneList = lazy(() => import('../pages/MilestoneList'))
const FlexiComboPage = lazy(() => import('../pages/FlexiCombo'))
const FlexiComboAddEdit = lazy(() => import('../pages/FlexiComboAddEdit'))
const ReferralMissionList = lazy(() => import('../pages/ReferralMission/ReferralMissionList'))
const ReferralMissionAddAndEdit = lazy(
  () => import('../pages/ReferralMission/ReferralMissionAddAndEdit'),
)
const GiftWithPurchasePage = lazy(() => import('pages/GiftWithPurchase/List'))
const GiftWithPurchaseAddPage = lazy(() => import('pages/GiftWithPurchase/Form'))
const GiftWithPurchaseAddProductPage = lazy(
  () => import('pages/GiftWithPurchase/ProductOrGiftList'),
)
const PurchaseWithPurchasePage = lazy(() => import('pages/PWP/List'))
const PurchaseWithPurchaseAddPage = lazy(() => import('pages/PWP/Form'))
const ReferralVIPList = lazy(() => import('pages/ReferralVIP/GetList'))
const UniqueVoucherCampaignList = lazy(() => import('../pages/UniqueVoucher/CampaignList'))
const UniqueVoucherVoucherList = lazy(() => import('../pages/UniqueVoucher/VoucherList'))
const UniqueVoucherVoucherPromoAddAndEdit = lazy(
  () => import('../pages/UniqueVoucher/VoucherPromoAddAndEdit'),
)
const PromotionChooseProductPage = lazy(() => import('pages/PWP/ProductList'))

export const FlashSaleRouter: RouterInstanceType = {
  name: 'FlashSaleRouter',
  Component: FlashSalePage,
  path: '/dashboard/flash-sale',
  routeType: 'PRIVATE',
  rbacPageID: flashSaleRBAC.pageID,
  allowedRoles: [],
  isDashboard: true,
}

export const AddEditFlashSaleRouter: RouterFeatureInterface<
  'AddEditFlashSaleRouter',
  '/dashboard/flash-sale/:prefix/:id'
> = {
  name: 'AddEditFlashSaleRouter',
  Component: AddEditFlashSale,
  path: '/dashboard/flash-sale/:prefix/:id',
  routeType: 'PRIVATE',
  rbacPageID: flashSaleAddEditRBAC.pageID,
  allowedRoles: [],
  isDashboard: true,
}

export const MilestoneAddEditRouter: RouterInstanceType = {
  name: 'MilestoneAddEditRouter',
  Component: MilestoneAddEdit,
  path: '/dashboard/milestone/:prefix(add|edit)/:milestoneId(\\d+)?',
  routeType: 'PRIVATE',
  allowedRoles: [
    'AUTH_CS_CAPTAIN',
    'AUTH_PRICING',
    'AUTH_SUPPLY_CHAIN',
    'AUTH_MARKETING',
    'AUTH_HO_CS_LEADER',
    'AUTH_HO_FRAUD',
    'AUTH_HO_CAMPAIGN',
    'AUTH_HO_PRODUCT_MANAGER',
    'AUTH_HO_QUALITY_ENGINEERING',
  ],
  isDashboard: true,
  rbacPageID: milestoneAddEditRBAC.pageID,
}

export const MilestoneListRouter: RouterInstanceType = {
  name: 'MilestoneListRouter',
  Component: MilestoneList,
  path: '/dashboard/milestone-list',
  routeType: 'PRIVATE',
  allowedRoles: [
    'AUTH_CS_CAPTAIN',
    'AUTH_PRICING',
    'AUTH_SUPPLY_CHAIN',
    'AUTH_MARKETING',
    'AUTH_HO_CS_LEADER',
    'AUTH_HO_FRAUD',
    'AUTH_HO_CAMPAIGN',
    'AUTH_HO_PRODUCT_MANAGER',
    'AUTH_HO_QUALITY_ENGINEERING',
  ],
  rbacPageID: milestoneListRBAC.pageID,
  isDashboard: true,
}

export const FlexiComboRouter: RouterInstanceType = {
  name: 'FlexiComboRouter',
  Component: FlexiComboPage,
  path: '/dashboard/flexi-combo',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: flexiComboRolesRBAC.pageID,
  isDashboard: true,
}

export const FlexiComboAddEditRouter: RouterInstanceType = {
  name: 'FlexiComboAddEdit',
  Component: FlexiComboAddEdit,
  path: '/dashboard/flexi-combo/:prefix(create|edit)/:id?',
  routeType: 'PRIVATE',
  allowedRoles: [],
  multiplePageID: {
    keySegment: 'prefix',
    pageIDmatchWithKeySegments: {
      create: flexiComboCreateRolesRBAC.pageID,
      edit: flexiComboEditRolesRBAC.pageID,
    },
  },
  isDashboard: true,
}

export const PromotionChooseProductRouter: RouterInstanceType = {
  name: 'PromotionChooseProductRouter',
  Component: PromotionChooseProductPage,
  path: `/dashboard/promotional/add-product/:origin(flexiComboAdd|flexiComboEdit|pwp)`,
  routeType: 'PRIVATE',
  allowedRoles: [],
  multiplePageID: {
    keySegment: 'origin',
    pageIDmatchWithKeySegments: {
      [enumOriginType.FLEXI_COMBO_ADD]: flexiComboChooseProductRolesRBAC.pageID,
      [enumOriginType.FLEXI_COMBO_EDIT]: flexiComboChooseProductRolesRBAC.pageID,
      [enumOriginType.PWP]: purchaseWithPurchaseAddProductRolesRBAC.pageID,
    },
  },
  isDashboard: true,
}

export const ReferralMissionRouter: RouterInstanceType = {
  name: 'ReferralMissionRouter',
  Component: ReferralMissionList,
  path: '/dashboard/referral-mission',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: referralMissionListRBAC.pageID,
  isDashboard: true,
}

export const ReferralMissionAddEditRouter: RouterInstanceType = {
  name: 'ReferralMissionAddEditRouter',
  Component: ReferralMissionAddAndEdit,
  path: '/dashboard/referral-mission/:prefix/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: referralMissionAddEditRBAC.pageID,
}

export const GiftWithPurchaseRouter: RouterInstanceType = {
  name: 'GiftWithPurchaseRouter',
  Component: GiftWithPurchasePage,
  path: '/dashboard/gift-with-purchase',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: giftWithPurchaseRolesRBAC.pageID,
  isDashboard: true,
}

export const GiftWithPurchaseAddRouter: RouterInstanceType = {
  name: 'GiftWithPurchaseAddRouter',
  Component: GiftWithPurchaseAddPage,
  path: '/dashboard/gift-with-purchase/add',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: giftWithPurchaseAddRolesRBAC.pageID,
  isDashboard: true,
}

export const GiftWithPurchaseEditRouter: RouterInstanceType = {
  name: 'GiftWithPurchaseEditRouter',
  Component: GiftWithPurchaseAddPage,
  path: '/dashboard/gift-with-purchase/edit/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: giftWithPurchaseEditRolesRBAC.pageID,
  isDashboard: true,
}

export const GiftWithPurchaseAddProductRouter: RouterInstanceType = {
  name: 'GiftWithPurchaseAddProductRouter',
  Component: GiftWithPurchaseAddProductPage,
  path: '/dashboard/gift-with-purchase-product-list',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: giftWithPurchaseAddProductRolesRBAC.pageID,
  isDashboard: true,
}
export const PurchaseWithPurchaseRouter: RouterInstanceType = {
  name: 'PurchaseWithPurchaseRouter',
  Component: PurchaseWithPurchasePage,
  path: '/dashboard/purchase-with-purchase',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: purchaseWithPurchaseRolesRBAC.pageID,
  isDashboard: true,
}

export const PurchaseWithPurchaseAddRouter: RouterInstanceType = {
  name: 'PurchaseWithPurchaseAddRouter',
  Component: PurchaseWithPurchaseAddPage,
  path: '/dashboard/purchase-with-purchase/add',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: purchaseWithPurchaseAddRolesRBAC.pageID,
  isDashboard: true,
}

export const PurchaseWithPurchaseEditRouter: RouterInstanceType = {
  name: 'PurchaseWithPurchaseEditRouter',
  Component: PurchaseWithPurchaseAddPage,
  path: '/dashboard/purchase-with-purchase/edit/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: purchaseWithPurchaseEditRolesRBAC.pageID,
  isDashboard: true,
}

export const ReferralVIPRouter: RouterInstanceType = {
  name: 'ReferralVIPRouter',
  Component: ReferralVIPList,
  path: '/dashboard/referral-vip/list',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: referralVIPRolesRBAC.pageID,
  isDashboard: true,
}

export const UniqueVoucherCampaignListRouter: RouterInstanceType = {
  name: 'UniqueVoucherCampaignList',
  Component: UniqueVoucherCampaignList,
  path: '/dashboard/unique-voucher/campaign-list',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: uniqueVoucherCampaignListRolesRBAC.pageID,
  isDashboard: true,
}

export const UniqueVoucherVoucherListRouter: RouterInstanceType = {
  name: 'UniqueVoucherVoucherList',
  Component: UniqueVoucherVoucherList,
  path: '/dashboard/unique-voucher/voucher-list',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: uniqueVoucherVoucherListRolesRBAC.pageID,
  isDashboard: true,
}

export const UniqueVoucherVoucherAddEditRouter: RouterInstanceType = {
  name: 'UniqueVoucherVoucherAddEdit',
  Component: UniqueVoucherVoucherPromoAddAndEdit,
  path: '/dashboard/unique-voucher/voucher/:prefix/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  rbacPageID: uniqueVoucherVoucherPromoAddEditRolesRBAC.pageID,
  isDashboard: true,
}

const PromotionRouter = [
  FlashSaleRouter,
  AddEditFlashSaleRouter,
  MilestoneAddEditRouter,
  MilestoneListRouter,
  FlexiComboRouter,
  FlexiComboAddEditRouter,
  ReferralMissionRouter,
  ReferralMissionAddEditRouter,
  GiftWithPurchaseRouter,
  GiftWithPurchaseAddRouter,
  GiftWithPurchaseEditRouter,
  GiftWithPurchaseAddProductRouter,
  PurchaseWithPurchaseRouter,
  PurchaseWithPurchaseAddRouter,
  PurchaseWithPurchaseEditRouter,
  ReferralVIPRouter,
  UniqueVoucherCampaignListRouter,
  UniqueVoucherVoucherListRouter,
  UniqueVoucherVoucherAddEditRouter,
  PromotionChooseProductRouter,
]

export const PromotionRouterDetail = generateRouterDetail(PromotionRouter)

export default PromotionRouter
